/* eslint-disable no-undef */
import { putHubspotReferrer } from '../HubspotData';

export const partnerStackSignUp = ({ firstName, lastName, username }) => {
  // 1. Populate the growsumo.data object
  growsumo.data.name = `${firstName} ${lastName}`;
  growsumo.data.email = username;
  // In this case, email is how I uniquely identify my customers
  growsumo.data.customer_key = username;

  // Register the signup with PartnerStack
  growsumo.createSignup();

  const data = {
    referral_source: 'PartnerStack'
  };

  growsumo?.data?.partner_key && putHubspotReferrer({ data });
};



// WEBPACK FOOTER //
// ./src/utils/partnerStackSignUp/partnerStackSignUp.js